import { NonNullableProperties } from '@/utils/types';

enum TaskStatus {
	// mirror enum for celery task status
	Pending = 'PENDING',
	Success = 'SUCCESS',
	Failure = 'FAILURE',
}

const READY_TASK_STATUSES = [TaskStatus.Success, TaskStatus.Failure];

interface TaskError {
	detail: string;
	code: string;
	metadata: unknown;
}

export interface ProcessTaskResponse {
	status: TaskStatus;
	info?: Record<string, unknown>;
	error?: TaskError;
}

interface FinalizeProcessTaskResponse extends Omit<ProcessTaskResponse, 'status'> {
	status: TaskStatus.Success | TaskStatus.Failure;
}

export type SuccessProcessTaskResponse = NonNullableProperties<Omit<ProcessTaskResponse, 'error'>, 'info'> & {
	status: TaskStatus.Success;
};

type ErrorProcessTaskResponse = NonNullableProperties<Omit<ProcessTaskResponse, 'info'>, 'error'> & {
	status: TaskStatus.Failure;
};

export type ProcessTaskResponseInfo = NonNullableProperties<Pick<ProcessTaskResponse, 'info'>, 'info'>['info'];

export enum Tasks {
	PublishWorkflow = 'publish-workflow',
	RestoreWorkflow = 'restore-workflow',
	InstallInstallableVersion = 'install-version',
	DuplicateWorkflow = 'duplicate-workflow',
	CreateSubflowFromNodes = 'create-subflow-from-nodes',
}
export const isErrorProcessTaskResponse = (resp: ProcessTaskResponse): resp is ErrorProcessTaskResponse =>
	resp.status === TaskStatus.Failure;
export const isSuccessProcessTaskResponse = (resp: ProcessTaskResponse): resp is SuccessProcessTaskResponse =>
	resp.status === TaskStatus.Success;
export const isFinalizeProcessTaskResponse = (resp: ProcessTaskResponse): resp is FinalizeProcessTaskResponse =>
	isFinalizedStatus(resp.status);

export const isFinalizedStatus = (status: TaskStatus) => READY_TASK_STATUSES.includes(status);
